import type * as THREE from "three";

const EPSILON = 1e-6;

// A circle is convex, so checking the vertices is exact for polygons and polylines alike.
function isInsideCircle({ points, center, radius }: { points: ReadonlyArray<THREE.Vector3>; center: THREE.Vector3; radius: number }): boolean {
	const limit = (radius + EPSILON) ** 2;

	return points.every((point) => (point.x - center.x) ** 2 + (point.z - center.z) ** 2 <= limit);
}

export { isInsideCircle };
